import Tooltip from '@material-ui/core/Tooltip';
import WarningIcon from '@material-ui/icons/Warning';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';
import IsolatedConceptSlat from './IsolatedConceptSlat';

const loadOptions = {
    predicates: [
        "http://www.w3.org/2004/02/skos/core#inScheme",
        "http://www.w3.org/2004/02/skos/core#prefLabel",
        "http://www.w3.org/2002/07/owl#deprecated",
        "http://www.w3.org/2008/05/skos-xl#prefLabel",
        "http://www.w3.org/2004/02/skos/core#narrower",
        "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
    ],
    tests: [
        {
            id: "http://www.w3.org/2008/05/skos-xl#prefLabel",
            join: [{
                predicate: "http://www.w3.org/2008/05/skos-xl#literalForm"
            }]
        }
    ]
};

class IsolatedConcept extends React.Component {

    render() {

        const { position, data, lang, onSelect, onBreakLink, viewLang, iriOptions, useWorkflow,
             activeConcept, hideInScheme, showInScheme, schemeIRI } = this.props;

        // If somebody else has deleted it we will now hide it
        if (data.pendingDeletion) return null;

        return (
            <div>
                <IsolatedConceptSlat
                    icon={
                        hideInScheme && data.inScheme && data.inScheme.length > 0 ?
                            <Tooltip data-test="added-to-scheme" title="This has recently been added to a scheme.">
                                <WarningIcon />
                            </Tooltip>
                            :
                            showInScheme && (!data.inScheme || data.inScheme.length === 0 || (schemeIRI && !data.inScheme.includes(schemeIRI))) ?
                                <Tooltip data-test="removed-from-scheme" title="This has recently been removed from this scheme.">
                                    <WarningIcon />
                                </Tooltip>
                                :
                                null
                    }
                    defaultLang={lang}
                    useWorkflow={useWorkflow}
                    position={position}
                    iriOptions={iriOptions}
                    activeConcept={activeConcept}
                    viewLang={viewLang}
                    data={data}
                    onSelect={onSelect}
                    onBreakLink={onBreakLink} />
            </div>
        );
    }
}

IsolatedConcept.defaultProps = {
    hideInScheme: false,
    showInScheme: false
};

IsolatedConcept.propTypes = {
    hideInScheme: PropTypes.bool,
    showInScheme: PropTypes.bool,
    schemeIRI: PropTypes.string,
    useWorkflow: PropTypes.bool,
    isReadOnly: PropTypes.bool.isRequired,
    data: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    viewLang: PropTypes.string,
    activeConcept: PropTypes.string,
    onSelect: PropTypes.func.isRequired,
    iriOptions: PropTypes.object
};

export default withGS(IsolatedConcept, ["ALL"], null, loadOptions, true);